"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ascendingComparator = function ascendingComparator(a, b) {
  return a - b;
};

var _default = ascendingComparator;
exports["default"] = _default;